module.exports = __webpack_public_path__ + "img/testimonios-ingles.b29cae41.jpg";